export const API_URL = 'https://lindos-backend.dotsoft.gr/api/'

export const API_KEY = '1Wt8DjIQ90GuPuovuI1O8M9Axe7OhZA4'